module.exports = __webpack_public_path__ + "media/newstyle/images/logo-mercado-color-caa6276ff16ee83f99e16a09cc592a06.png";